module.exports = __webpack_public_path__ + "img/visual-system.19459371.svg";